const isValidEmail = (email: string): boolean => {
    const exp: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return exp.test(email);
};


export { isValidEmail };
